<template>
  <section>
    <framed-image :navigate-to="groupImage" :images="groupImages" />
    <div class="mx-2 mt-12">
      <h2>What type of cake would you like?</h2>
      <div class="buttons flex-wrap">
        <standard-button 
          v-for="item in filteredGroups" :key="item.id"
          @click="setGroup(item.id)"
          :active="value == item.id"
        >
          <template slot="image"><framed-image frame-style="small" :images="[item.image]" /></template>
          {{item.name}}
        </standard-button>
      </div>
    </div>
  </section>
</template>


<script>
import FramedImage from './FramedImage'
import StandardButton from './ImageButton'
import { filter, map, findIndex, last } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    group: {},
    groups: {
      type: Array,
      default() {
        return ["swirl","ombre","sprinkle","splatter","marble","abstract","drip","dino","mermaid"]
      }
    }
  },
  components: {
    FramedImage,
    StandardButton
  },
  methods: {
    publicId(image) {
      return last(image.split("/"))
    },
    setGroup(id) {
      this.$emit('input',id)
      this.$scrollTo(document.getElementById('box'), 1000, { offset: -50 })
    }
  },
  computed: {
    filteredGroups() {
      return filter(this.$root.$data.groups, o => this.groups.includes(o.id))
    },
    groupImages() {
      return map(this.filteredGroups, 'image')
    },
    groupImage() {
      return Math.floor(findIndex(this.filteredGroups, {id: this.value}) / 2)
    },
  }
}
</script>
